import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetElevenlabsQuotaV1Response } from './get-elevenlabs-quota-v1-response';
import { getElevenlabsQuotaV1ResponseSchema } from './get-elevenlabs-quota-v1-response';

export async function getElevenlabsQuotaV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetElevenlabsQuotaV1Response>> {
  return getRequest<IGetElevenlabsQuotaV1Response>({
    path: '/sys/elevenlabs/v1/quota',
    schema: getElevenlabsQuotaV1ResponseSchema,
    options,
  });
}
